/** @format */

import { useRef, MouseEventHandler } from "react";

export function useThrottleClick<T extends Element>(onClick?: MouseEventHandler<T>, throttle = 500) {
  const pause = useRef(false);
  const throttleClick: MouseEventHandler<T> = (event) => {
    if (!pause.current) {
      onClick?.(event);
      pause.current = true;
    }
    setTimeout(() => {
      pause.current = false;
    }, throttle);
  };
  return throttleClick;
}
